import { motion, AnimatePresence } from "framer-motion";
import { X, Key, ArrowSquareOut, CurrencyDollar, CheckCircle } from "@phosphor-icons/react";
import { useI18n } from "@/i18n";

export function ApiKeyGuideModal({ open, onClose }) {
  const { t } = useI18n();
  const steps = [t("apikey.step1"), t("apikey.step2"), t("apikey.step3")];

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[95] flex items-center justify-center bg-lc-navy/70 p-4 backdrop-blur-sm"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid="apikey-guide-modal"
        >
          <motion.div
            className="w-full max-w-md overflow-hidden rounded-xl border border-lc-ink/10 bg-white shadow-2xl"
            initial={{ opacity: 0, y: 20, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 20, scale: 0.97 }}
            transition={{ type: "spring", stiffness: 320, damping: 30 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-3 border-b border-lc-ink/10 bg-lc-paper px-5 py-4">
              <div className="flex items-center gap-2.5">
                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-lc-ocean/10">
                  <Key size={20} weight="duotone" className="text-lc-ocean" />
                </div>
                <h3 className="font-serif text-lg text-lc-ink leading-tight">{t("apikey.title")}</h3>
              </div>
              <button onClick={onClose} data-testid="apikey-guide-close" className="text-lc-steel hover:text-lc-ink transition-colors duration-200">
                <X size={20} />
              </button>
            </div>

            <div className="space-y-4 px-5 py-5">
              {steps.map((s, i) => (
                <div key={i} className="flex gap-3" data-testid={`apikey-step-${i + 1}`}>
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-lc-ocean text-[11px] font-bold text-white">
                    {i + 1}
                  </span>
                  <p className="text-sm leading-relaxed text-lc-ink">
                    <span className="font-mono text-[10px] uppercase tracking-wider text-lc-steel">{t("apikey.stepLabel")} {i + 1}</span>
                    <br />
                    {s}
                  </p>
                </div>
              ))}

              <div className="flex gap-2.5 rounded-md border border-lc-ok/25 bg-lc-ok/10 p-3" data-testid="apikey-cost-note">
                <CurrencyDollar size={18} weight="duotone" className="mt-0.5 shrink-0 text-lc-ok" />
                <p className="text-[12px] leading-relaxed text-lc-ink">{t("apikey.cost")}</p>
              </div>

              <a
                href="https://console.anthropic.com/settings/keys"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="apikey-console-link"
                className="flex w-full items-center justify-center gap-2 rounded-sm bg-lc-ocean px-4 py-2.5 text-sm font-semibold text-white transition-opacity duration-200 hover:opacity-90"
              >
                console.anthropic.com <ArrowSquareOut size={15} weight="bold" />
              </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ApiKeyGuideModal;
